<!-- Apps -->
<div data-kt-dropdown="true" data-kt-dropdown-offset="10px, 10px" data-kt-dropdown-offset-rtl="-10px, 10px"
    data-kt-dropdown-placement="bottom-end" data-kt-dropdown-placement-rtl="bottom-start">
    <button
        class="kt-btn kt-btn-ghost kt-btn-icon hover:bg-primary/10 hover:[&_i]:text-primary kt-dropdown-open:bg-primary/10 kt-dropdown-open:[&_i]:text-primary size-9 rounded-full"
        data-kt-dropdown-toggle="true">
        <i class="ki-filled ki-element-11 text-lg">
        </i>
    </button>
    <div class="kt-dropdown-menu w-screen max-w-[320px] p-0" data-kt-dropdown-menu="true">
        <div
            class="flex items-center justify-between gap-2.5 border-b border-b-border px-5 py-3 text-xs font-medium text-secondary-foreground">
            <span>
                Apps
            </span>
            <span>
                Enabled
            </span>
        </div>
        <div class="kt-scrollable-y-auto flex max-h-[400px] flex-col divide-y divide-border">
            <div class="flex flex-wrap items-center justify-between gap-2 px-5 py-3.5">
                <div class="flex flex-wrap items-center gap-2">
                    <div
                        class="bg-accent/60 flex size-10 shrink-0 items-center justify-center rounded-full border border-border">
                        <img alt="" class="size-6" src="assets/media/brand-logos/jira.svg" />
                    </div>
                    <div class="flex flex-col">
                        <a class="hover:text-primary text-sm font-semibold text-mono" href="#">
                            Jira
                        </a>
                        <span class="text-xs font-medium text-secondary-foreground">
                            Project management
                        </span>
                    </div>
                </div>
                <div class="flex items-center gap-2 lg:gap-5">
                    <input class="kt-switch" type="checkbox" value="1" />
                </div>
            </div>
            <div class="flex flex-wrap items-center justify-between gap-2 px-5 py-3.5">
                <div class="flex flex-wrap items-center gap-2">
                    <div
                        class="bg-accent/60 flex size-10 shrink-0 items-center justify-center rounded-full border border-border">
                        <img alt="" class="size-6" src="assets/media/brand-logos/inferno.svg" />
                    </div>
                    <div class="flex flex-col">
                        <a class="hover:text-primary text-sm font-semibold text-mono" href="#">
                            Inferno
                        </a>
                        <span class="text-xs font-medium text-secondary-foreground">
                            Ensures healthcare app
                        </span>
                    </div>
                </div>
                <div class="flex items-center gap-2 lg:gap-5">
                    <input checked="" class="kt-switch" type="checkbox" value="1" />
                </div>
            </div>
            <div class="flex flex-wrap items-center justify-between gap-2 px-5 py-3.5">
                <div class="flex flex-wrap items-center gap-2">
                    <div
                        class="bg-accent/60 flex size-10 shrink-0 items-center justify-center rounded-full border border-border">
                        <img alt="" class="size-6" src="assets/media/brand-logos/evernote.svg" />
                    </div>
                    <div class="flex flex-col">
                        <a class="hover:text-primary text-sm font-semibold text-mono" href="#">
                            Evernote
                        </a>
                        <span class="text-xs font-medium text-secondary-foreground">
                            Notes management app
                        </span>
                    </div>
                </div>
                <div class="flex items-center gap-2 lg:gap-5">
                    <input checked="" class="kt-switch" type="checkbox" value="1" />
                </div>
            </div>
            <div class="flex flex-wrap items-center justify-between gap-2 px-5 py-3.5">
                <div class="flex flex-wrap items-center gap-2">
                    <div
                        class="bg-accent/60 flex size-10 shrink-0 items-center justify-center rounded-full border border-border">
                        <img alt="" class="size-6" src="assets/media/brand-logos/gitlab.svg" />
                    </div>
                    <div class="flex flex-col">
                        <a class="hover:text-primary text-sm font-semibold text-mono" href="#">
                            Gitlab
                        </a>
                        <span class="text-xs font-medium text-secondary-foreground">
                            DevOps platform
                        </span>
                    </div>
                </div>
                <div class="flex items-center gap-2 lg:gap-5">
                    <input class="kt-switch" type="checkbox" value="1" />
                </div>
            </div>
            <div class="flex flex-wrap items-center justify-between gap-2 px-5 py-3.5">
                <div class="flex flex-wrap items-center gap-2">
                    <div
                        class="bg-accent/60 flex size-10 shrink-0 items-center justify-center rounded-full border border-border">
                        <img alt="" class="size-6" src="assets/media/brand-logos/google-webdev.svg" />
                    </div>
                    <div class="flex flex-col">
                        <a class="hover:text-primary text-sm font-semibold text-mono" href="#">
                            Google webdev
                        </a>
                        <span class="text-xs font-medium text-secondary-foreground">
                            Building web expierences
                        </span>
                    </div>
                </div>
                <div class="flex items-center gap-2 lg:gap-5">
                    <input checked="" class="kt-switch" type="checkbox" value="1" />
                </div>
            </div>
        </div>
        <div class="grid border-t border-t-border p-5">
            <a class="kt-btn kt-btn-outline justify-center" href="#">
                Go to Apps
            </a>
        </div>
    </div>
</div>
<!-- End of Apps -->
